import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth-guard/auth-guard.service';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  {
    path: 'login',
    loadChildren: () =>
      import('./public/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./public/register/register.module').then(
        (m) => m.RegisterPageModule,
      ),
  },
  // {
  //   path: 'app',
  //   canActivate: [AuthGuardService],
  //   loadChildren: () =>
  //     import('./app-routing.module').then((m) => m.AppRoutingModule),
  // },
  {
    path: 'changePassword',
    loadChildren: () =>
      import('./public/change-password/change-password.module').then(
        (m) => m.ChangePasswordPageModule,
      ),
  },
  {
    path: 'forgotPassword',
    loadChildren: () =>
      import('./public/forgot-password/forgot-password.module').then(
        (m) => m.ForgotPasswordPageModule,
      ),
  },

  {
    path: 'app',
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./app/dashboard/dashboard.module').then(
            (m) => m.DashboardPageModule,
          ),
      },
      {
        path: 'actionsWindow',
        loadChildren: () =>
          import('./app/actions-window/actions-window.module').then(
            (m) => m.ActionsWindowPageModule,
          ),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },

  {
    path: 'ag-grid-test',
    loadComponent: () =>
      import('./components/ag-grid-sanity-test/ag-grid-sanity-test.component').then(
        (m) => m.AgGridSanityTestComponent,
      ),
  },

  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
